class UpdateCharacterCount {
	private readonly inputField: HTMLInputElement;

	constructor(private readonly element: HTMLElement) {
		const field = element.querySelector<HTMLInputElement>(".characCountInput");

		if (!field) {
			throw new Error("Could not locate .characCountInput");
		}

		this.inputField = field;

		if (field.value) {
			this.updateCharacLength();
		}
	}

	updateCharacLength(): void {
		const inputLength = this.inputField.value.length;

		const spanTxt = this.element.querySelector("span");

		const txtLimit = spanTxt?.innerText.split("/")[1] || "0";

		if (spanTxt) {
			spanTxt.innerHTML = `${inputLength}/${txtLimit}`;

			spanTxt.style.color =
				inputLength >= parseInt(txtLimit, 10) ? "#dd0031" : "inherit";
		}
	}
}

document

	.querySelectorAll<HTMLElement>(".characCountTracker")

	.forEach(elem => {
		const counter = new UpdateCharacterCount(elem);

		const trackerInputField = elem.querySelector(".characCountInput");

		trackerInputField?.addEventListener("keyup", () =>
			counter.updateCharacLength()
		);
	});
